import React from "react";
import styles from "./index.module.scss";
import { renderRichText } from "@/utils/formatters";
import { useRouter } from "next/router";

const LeapSmartControl = ({ leapSmartControlData }) => {
const { locale } = useRouter()
  if (!leapSmartControlData) return null;

  const {
    description,
    images = [],
  } = leapSmartControlData;

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        {images.map((item, index) => {
            
            const { imageUrl, alt } = item.fields || {};
            if (!imageUrl) return null;

            return (
            <div className={styles.card} key={index}>
                <img
                src={imageUrl}
                alt={alt || ""}
                className={styles.image}
                />
            </div>
            )
        })}
        {description && (
            <div className={styles.details}>
              <div className={styles.description}>
                {renderRichText(description, locale)}
              </div>
            </div>
        )}
      </div>
    </section>
  );
};

export default LeapSmartControl;
